import {
  Box,
  Button,
  Checkbox,
  Grid,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  ingredients,
} from "@mui/material";
import { ErrorMessage, Formik } from "formik";
import React, { useEffect } from "react";
import { useStyles } from "./styles";
import Pen from "../../../assets/images/CourseManagement/pen.svg";
import Close from "../../../assets/images/CourseManagement/close.svg";
import DeleteModal from "../../../common/DeleteModal";
import CustomExpandMore from "../../../common/CustomExpandMore";
import { useNavigate } from "react-router-dom";
import useArrival from "../../../Hooks/arrival";
import * as Yup from "yup";
import { TableLoader } from "../../../common/Loader";
import CustomPagination from "../../../common/Pagination";
import { useState } from "react";
import usePagination from "../../../common/usePagination";
import { useCallback } from "react";
import { max } from "lodash";
import { setRedirection } from "../../../store/arrival";
import useAuthStore from "../../../Hooks/auth";
import { getStatusInBoolen, getToggleStatus } from "../../../Utils/deleteutils";
import ToggleSwitch from "../../../common/ToggleSwitch";

const columns = [
  {
    id: "S.No",
    label: "S.No",
    align: "center",
    sortby: true,
  },
  {
    id: "bookTitle",
    sortby: true,
    label: "Book Title",
    align: "center",
  },
  {
    id: "author",
    sortby: true,
    label: "Author",
    align: "center",
  },
  {
    id: "date",
    label: "Arrival Date",
    align: "center",
    sortby: true,
  },
  {
    id: "edit",
    label: "Edit",
    align: "center",
  },
  {
    id: "delete",
    label: "Actions",
    align: "center",
  },
];

const Arrivals = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  // const [page, setPage] = useState(1);
  // const [PerPage, setPerPage] = useState(10);
  // const [offset, setOffset] = useState(0);
  const [check, setCheck] = useState();

  const { institutionId } = useAuthStore();
  // Get the current date
  const currentDate = new Date();

  // Subtract 30 days from the current date
  const minDate = new Date(currentDate);
  minDate.setDate(currentDate.getDate() - 30);

  const maxDate = new Date(currentDate);
  maxDate.setDate(currentDate.getDate() + 70);

  const handleOpen = () => {
    setOpen(true);
  };
  const navigate = useNavigate();
  const {
    addNewArrivalInfo,
    arrivalList,
    getNewArrivalInfo,
    deleteArrivalInfo,
    setActiveArrivalAction,
    loading,
    activeArrivals,
    setRedirectAction,
    setPerPageAction,
    perPage,
    setPageAction,
    setOffsetAction,
    page,
    offset,
  } = useArrival();
  const [deleteStatus, setDeleteStatus] = React.useState();

  const initValues = {
    title: "",
    author: "",
    arrivalDate: "",
    institutionId,
  };
  const attivalListSchema = Yup.object().shape({
    title: Yup.string().required("* Please enter book title name"),
    author: Yup.string().required("* Please enter author name "),
    arrivalDate: Yup.date()
      .min(
        minDate,
        `* ${minDate.toISOString().split("T")[0]} is the minimum date`
      )
      .max(
        maxDate,
        `* ${maxDate.toISOString().split("T")[0]}  is the maximum date`
      )
      .required("* Please select date"),
  });

  console.log("arrivalList", arrivalList);

  const handlePage = (e) => {
    // setPerPage(e.target.value);
    setPerPageAction(e.target.value);
    setOffsetAction(0)
    setPageAction(1)
  };

  const count =
    (arrivalList &&
      Math.ceil(arrivalList?.totalNoOfRecord?.totalNoOfRecord / perPage)) ||
    0;
  const _DATA = usePagination(arrivalList?.libraryBooks, perPage);

  const handleChange = useCallback(
    (e, p) => {
      // setPage(p);
      // setOffset(p * PerPage - PerPage);
      setPageAction(p);
      setOffsetAction(p * perPage - perPage);
      _DATA.jump(p);
    },
    [perPage, page]
  );

  useEffect(() => {
    setRedirectAction(false);
  }, []);

  useEffect(() => {
    getNewArrivalInfo({
      limit: perPage,
      offset: offset,
      institutionId,
    });
  }, [perPage, offset]);

  return (
    <Stack className={classes.arrival}>
      <Grid container>
        <Grid item lg={10} xl={10} sm={12}>
          <Stack>
            <Box sx={{ width: "100%" }}>
              <Paper
                sx={{
                  width: "100%",
                  borderRadius: "20px",
                  filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                  boxShadow: "none",
                }}
              >
                <Stack sx={{ p: 4 }}>
                  <Typography
                    sx={{ py: 2 }}
                    className={classes.add_course_text}
                  >
                    Add New Arrivals
                  </Typography>
                  <Formik
                    initialValues={initValues}
                    validateOnBlur={false}
                    validateOnChange={false}
                    validationSchema={attivalListSchema}
                    onSubmit={(values, { resetForm }) => {
                      addNewArrivalInfo(values);
                      resetForm({ values: "" });
                    }}
                  >
                    {(formik) => {
                      const {
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        values,
                      } = formik;
                      return (
                        <form onSubmit={handleSubmit}>
                          {/* {loading? (<div><Loader /></div>):(  */}
                          <div>
                            <Grid
                              container
                              sx={{ py: 2 }}
                              className={classes.form_add_course}
                              spacing={4}
                            >
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack>
                                    <Typography className={classes.label}>
                                      Book Title
                                    </Typography>
                                  </Stack>
                                  <Stack>
                                    <TextField
                                      id="title"
                                      name="title"
                                      placeholder="Enter title"
                                      className={
                                        errors.title && touched.title
                                          ? classes.inputError
                                          : classes.inputNoError
                                      }
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.title}
                                    />
                                    <ErrorMessage
                                      name="title"
                                      component="span"
                                      className={classes.error}
                                    />
                                  </Stack>
                                </Stack>
                              </Grid>
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack>
                                    <Typography className={classes.label}>
                                      Arrival Date
                                    </Typography>
                                  </Stack>
                                  <Stack
                                    sx={{
                                      width: 230,
                                    }}
                                  >
                                    <TextField
                                      id="arrivalDate"
                                      type="date"
                                      // defaultValue={date.toISOString().split('T')[0]}
                                      name="arrivalDate"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.arrivalDate}
                                      // inputProps={{ min: "1950-01-01" }}
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      placeholder="Enter Date"
                                    />
                                    <ErrorMessage
                                      name="arrivalDate"
                                      component="span"
                                      className={classes.error}
                                    />
                                  </Stack>
                                </Stack>
                              </Grid>
                            </Grid>
                            <Grid
                              container
                              sx={{ pb: 2 }}
                              className={classes.form_add_course}
                              spacing={4}
                            >
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack>
                                    <Typography
                                      className={classes.label}
                                      sx={{ pr: 2 }}
                                    >
                                      Author
                                    </Typography>
                                  </Stack>
                                  <Stack>
                                    <TextField
                                      id="author"
                                      name="author"
                                      placeholder="Enter Author"
                                      className={
                                        errors.author && touched.author
                                          ? classes.inputError
                                          : classes.inputNoError
                                      }
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.author}
                                    />
                                    <ErrorMessage
                                      name="author"
                                      component="span"
                                      className={classes.error}
                                    />
                                  </Stack>
                                </Stack>
                              </Grid>
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack>
                                    <Typography
                                      className={classes.label}
                                    ></Typography>
                                  </Stack>
                                  <Stack>
                                    <Button
                                      type="submit"
                                      sx={{
                                        px: 1,
                                        py: 1.5,
                                        borderRadius: "50px",
                                        width: "220px",
                                      }}
                                      className={classes.add_arrival}
                                    >
                                      Add Arrivals
                                    </Button>
                                  </Stack>
                                </Stack>
                              </Grid>
                            </Grid>
                          </div>
                          {/* )} */}
                        </form>
                      );
                    }}
                  </Formik>
                </Stack>
              </Paper>
            </Box>
          </Stack>
          <Stack sx={{ marginTop: "20px" }}>
            <Box sx={{ width: "100%" }}>
              <Paper
                sx={{
                  width: "100%",
                  borderRadius: "20px",
                  filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                  boxShadow: "none",
                  maxHeight: "575px",
                  overflowY: "auto",
                }}
              >
                <Stack sx={{ p: 4 }}>
                  <TableContainer sx={{ maxHeight: 440 }}>
                    {loading ? (
                      <div>
                        {" "}
                        <TableLoader />
                      </div>
                    ) : (
                      <Table
                        aria-label="sticky table"
                        className={classes.root}
                        style={{ padding: 0 }}
                      >
                        <TableHead style={{ position: "sticky", top: 0 }}>
                          <TableRow classes={{ root: classes.thead }}>
                            {columns.map((column) => (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                  minWidth: column.minWidth,
                                  paddingLeft: column.paddingLeft,
                                }}
                                classes={{ root: classes.columnData }}
                              >
                                {column.label}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>

                        <TableBody classes={{ root: classes.tBody }}>
                          {arrivalList?.libraryBooks?.length > 0 ? (
                            arrivalList?.libraryBooks?.map((_el, index) => (
                              <TableRow tabIndex={-1} key={index}>
                                {columns.map((column) => {
                                  // const value = _el[column.id];
                                  //console.log("el value", _el);
                                  return (
                                    <TableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      {column.id === "S.No" ? (
                                        <Stack sx={{ alignItems: "center" }}>
                                          <span>{offset + index + 1}</span>
                                          {/* <Checkbox defaultChecked /> */}
                                        </Stack>
                                      ) : column.id === "bookTitle" ? (
                                        _el.title
                                      ) : column.id === "author" ? (
                                        _el.author
                                      ) : column.id === "date" ? (
                                        _el.arrivalDate
                                      ) : column.id === "edit" ? (
                                        <Stack
                                          sx={{
                                            alignItems: "center",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            navigate(
                                              "/arrivals/updateArrivals",
                                              {
                                                state: _el,
                                              }
                                            );
                                            navigate(
                                              "/arrivals/updateArrivals",
                                              {
                                                state: _el,
                                              }
                                            );
                                          }}
                                        >
                                          <img src={Pen} alt="pen" />
                                        </Stack>
                                      ) : (
                                        <Stack
                                          sx={{
                                            alignItems: "center",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setActiveArrivalAction(_el.id);
                                            setOpen(true);
                                            setDeleteStatus(
                                              getToggleStatus(_el.status)
                                            );
                                            setCheck(
                                              getToggleStatus(_el.status)
                                            );
                                          }}
                                        >
                                          <ToggleSwitch
                                            defaultChecked
                                            checked={getStatusInBoolen(
                                              _el.status
                                            )}
                                          />
                                        </Stack>
                                      )}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={6}
                                sx={{ borderBottom: "none" }}
                              >
                                <Stack
                                  sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  No Data
                                </Stack>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    )}
                  </TableContainer>
                  {arrivalList?.totalNoOfRecord?.totalNoOfRecord > 10 && (
                    <CustomPagination
                      count={count}
                      page={page}
                      onPageChange={handleChange}
                      handlePage={handlePage}
                      perPage={perPage}
                    />
                  )}
                </Stack>
              </Paper>
            </Box>
          </Stack>
        </Grid>
        <Grid item lg={4} sm={12}></Grid>
      </Grid>
      <DeleteModal
        setOpen={setOpen}
        open={open}
        deleteAction={deleteArrivalInfo}
        active={activeArrivals}
        textmsg={
          check === "InActive"
            ? "Are you sure you want to Deactivate this Arrivals?"
            : "Are you sure you want to Active this Arrivals?"
        }
        component={"arrival"}
        status={deleteStatus}
      />
    </Stack>
  );
};

export default Arrivals;
